import React from 'react';

import Button from '../../../../library/button/button';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import ProductPromoCountdown from '../../../../components/product-promo-countdown/product-promo-countdown';
import { TagsSolidIcon } from '../../../../shared/icons/icons';

import {
  useModal,
  useMyAccount,
  useProductEntryDataLayerValues
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { setPlpScrollToHash } from '../../../../shared/utils/back-to-results/back-to-results';
import { slugify } from '../../../../shared/utils/format/format';
import {
  getProductPromotions,
  getPromoCountdownText
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';
import { PROMOTION_CONDITION_TYPES } from '../../../../shared/constants/cart';
import { SIGN_IN_MODAL } from '../../../../shared/constants/modals';

import styles from './product-list-card-promos.scss';

interface ProductListCardPromosProps {
  isCompare?: boolean;
  product?: ProductData;
}

function ProductListCardPromos(props: ProductListCardPromosProps) {
  const { isCompare = false, product } = props;

  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();
  const { closeModal, openModal } = useModal();
  const { isLoggedIn } = useMyAccount();

  const productPromotions = getProductPromotions(product);

  function getShouldShowSignIn(promo) {
    const { instantPromotion, promotionConditionType } = promo;

    return (
      (promotionConditionType === PROMOTION_CONDITION_TYPES.MYACCOUNT ||
        promotionConditionType === PROMOTION_CONDITION_TYPES.TREADWELL ||
        Boolean(instantPromotion)) &&
      !isLoggedIn
    );
  }

  return (
    <>
      {productPromotions.map(promo => {
        const countdownText = getPromoCountdownText(promo?.endDate);
        const promoText =
          promo?.shortDescription !== null
            ? promo.shortDescription
            : promo?.description;
        return (
          <div className={styles['container']} key={slugify(promo?.title)}>
            <div className={styles['promo-container']}>
              <TagsSolidIcon className={styles['icon']} />

              {getShouldShowSignIn(promo) && (
                <Button
                  className={styles['promo']}
                  onClick={() =>
                    openModal(SIGN_IN_MODAL, {
                      heading: promoText,
                      onSignIn: () => {
                        setPlpScrollToHash(product?.code);
                        closeModal();
                      },
                      shouldUseHashRouter: false,
                      subtitle: promo?.subtitle
                    })
                  }
                >
                  {promoText}
                </Button>
              )}

              {!getShouldShowSignIn(promo) && promo?.detailsUrl && (
                <Link
                  className={styles['promo']}
                  onClick={() =>
                    trackAction(
                      'product_savings_available_click',
                      getProductEntryDataLayerValues(product)
                    )
                  }
                  target="_blank"
                  to={promo.detailsUrl}
                >
                  {promoText}
                </Link>
              )}

              {!getShouldShowSignIn(promo) && !promo?.detailsUrl && (
                <Typography className={styles['promo']} tag="span">
                  {promoText}
                </Typography>
              )}
            </div>
            <div className={isCompare ? styles['compare-page-promo'] : ''}>
              {countdownText && (
                <ProductPromoCountdown countdownText={countdownText} />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}

export default ProductListCardPromos;
